import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-comprobante-toku',
  templateUrl: './comprobante-toku.component.html',
  styleUrls: ['./comprobante-toku.component.sass'],
})
export class ComprobanteTokuComponent implements OnInit {

  isError: boolean = false;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.isError = params['status'] === 'error';
    });
  }

}
